import React from 'react';
import InviteSection from './invite-section/InviteSection';
import OrganizersList from './organizers-list/OrganizersList';
import { LoadingSpinner } from '@gik/ui';
import Organizer from '../../models/inkind-organizers/Organizer';
import UserProfileAPI from '../../api/UserProfileAPI';

export interface IInkindOrganizersProps {
  routeId: string;
}

export default function InKindOrganizers({ routeId }: React.PropsWithChildren<IInkindOrganizersProps>): JSX.Element {
  const [pageOwner, setPageOwner] = React.useState<Organizer>(null);
  const [pageOrganizers, setPageOrganizers] = React.useState<Organizer[]>(null);
  const [pageInvitees, setPageInvitees] = React.useState<Organizer[]>(null);

  React.useEffect(() => {
    if (!pageOwner || !pageOrganizers || !pageInvitees) {
      refreshPageOrganizers();
    }
  });

  const refreshPageOrganizers = async () => {
    const userProfileApi: UserProfileAPI = new UserProfileAPI();
    const inkind = await userProfileApi.getPage(routeId);
    const invitees = await userProfileApi.getPagePendingInvitees(routeId);

    const owner = inkind.getOwner();
    const organizers = inkind.getOrganizers().filter(organizer => !organizer.pendingInvitation);

    setPageOwner(owner);
    setPageOrganizers(organizers);
    setPageInvitees(invitees);
  };

  return (
    <div className="inkind-organizers">
      <section className="inkind-organizers-title">Organizers</section>
      <InviteSection
        pageOwner={pageOwner}
        pageOrganizers={pageOrganizers}
        pageInvitees={pageInvitees}
        routeId={routeId}
        onSendInvitation={refreshPageOrganizers}
      />
      {pageOwner && pageOrganizers && pageInvitees ? (
        <OrganizersList
          onRemoveOrganizer={refreshPageOrganizers}
          onUpdateSettings={refreshPageOrganizers}
          pageOwner={pageOwner}
          pageOrganizers={pageOrganizers}
          pageInvitees={pageInvitees}
          routeId={routeId}
        />
      ) : (
        <LoadingSpinner />
      )}
    </div>
  );
}
